import styled from 'styled-components';

type Area =
  | 'cep'
  | 'logradouro'
  | 'numero'
  | 'bairro'
  | 'complemento'
  | 'cidade';

export const ContainerDadosEntrega = styled.section`
  display: flex;
  flex-direction: column;
`;

/** Grid raiz da seção (2 linhas no desktop, quebrando responsivo) */
export const GridDadosEntrega = styled.div`
  /* espaçamentos */
  --gap-x: 1rem;
  --gap-y: 0.25rem;

  display: grid;
  gap: var(--gap-y) var(--gap-x);
  align-items: end;

  /* Desktop/Large: 4 colunas com áreas nomeadas */
  grid-template-columns: minmax(120px, 160px) 1fr minmax(92px, 140px) minmax(
      220px,
      360px
    );
  grid-template-areas:
    'cep logradouro numero bairro'
    'complemento complemento cidade cidade';

  /* <= 1024px: 3 colunas */
  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      'cep numero bairro'
      'logradouro logradouro logradouro'
      'complemento complemento cidade';
  }

  /* <= 768px: 2 colunas */
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'cep numero'
      'logradouro logradouro'
      'bairro bairro'
      'complemento complemento'
      'cidade cidade';
  }

  /* <= 480px: 1 coluna empilhada */
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'cep'
      'logradouro'
      'numero'
      'bairro'
      'complemento'
      'cidade';
  }
`;

/** Wrapper de campo que injeta a área do grid e previne overflow */
export const FieldDadosEntrega = styled.div<{ area: Area }>`
  grid-area: ${({ area }) => area};
  min-width: 0;
  & > * {
    width: 100%;
  }
`;
